import type { FaireProductEntity } from "../../entity_types/product";

export const p_cyp4gcrzrj: FaireProductEntity = {
  token: "p_cyp4gcrzrj",
  type: "product",
  name: "Small Brass Fox Figurine",
  brandToken: "b_q8ypma3xp2",
  brandName: "Superior Stones & Gifts INTL LLP",
  imageUrl:
    "https://cdn.faire.com/fastly/4f6178ab8972f1c92458441914e86ff21d0aa59938ed1e3dbb62fc553141ce9b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30f83bafbaceca5f25d0877540e1539c2db1e5a66ccf4a3c27a5ccfd0967d3b9.jpeg",
    "https://cdn.faire.com/fastly/fe67bb0b629dca1a46f92e51d3f9a18ecf54803be4f004808753c9efc8ff2a3c.jpeg",
  ],
  priceDollars: 3.6,
  description:
    "Small Brass Fox Figurine, quality castings with good details.\n\nMeasures 40x26mm\n",
  tags: [],
  msrpDollars: 7.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:49.021Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
